module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_7042.1b00e5ca.png";